import { render, staticRenderFns } from "./ModifyStaff.vue?vue&type=template&id=ff8f1518&scoped=true&"
import script from "./ModifyStaff.vue?vue&type=script&lang=js&"
export * from "./ModifyStaff.vue?vue&type=script&lang=js&"
import style0 from "./ModifyStaff.vue?vue&type=style&index=0&id=ff8f1518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f1518",
  null
  
)

export default component.exports